// src/utils.js
// Converts a File into a Base64 data URL string
export function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('File reading failed'));
    reader.onload  = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}